import { PageHeader } from '@/components/common/PageHeader';
import { PerksSection } from '@/features/trusted-partners/components/PerksSection';
import { TrustedPartnersHero } from '@/features/trusted-partners/components/TrustedPartnersHero';
import { TRUSTED_PARTNERS_STRINGS as S } from '@/features/trusted-partners/trusted-partners.constants';

/**
 * Network > Startup Perks (MYN-252): every live offer on its own page, laid out
 * like the Trusted Partners page (hero, then the section). Open to every
 * logged-in persona, the same as Trusted Partners (A-90). Reverses the earlier
 * "no separate Perks page" decision at the client's request.
 */
export function TrustedPartnersPerksPage() {
  return (
    <div className="min-h-full bg-page-bg">
      {/* No breadcrumb, matching the Trusted Partners page (UX sheet v2). */}
      <PageHeader title={S.PERKS_PAGE_TITLE} />
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 px-4 py-8">
        <TrustedPartnersHero eyebrow={S.PERKS_HERO_EYEBROW} title={S.PERKS_HERO_TITLE} subtitle={S.PERKS_HERO_SUBTITLE} />
        <PerksSection />
      </div>
    </div>
  );
}
